import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ViewState {
  currentView: string | null;
}

const initialState: ViewState = {
  currentView: null
};

const viewSlice = createSlice({
  name: 'view',
  initialState,
  reducers: {
    setCurrentView(state, action: PayloadAction<string | null>) {
      state.currentView = action.payload;
    }
  },
});

export const { setCurrentView } = viewSlice.actions;
export default viewSlice.reducer;